import axiosWrapper from "common/axiosWrapper";
// eslint-disable-next-line no-unused-vars
import EventPicksDto from "common/types/EventPicksDto";
import UserManager from "common/userManager";

const baseUrl = "/api/picks";

/** The Pick service which calls the API endpoints for the Pick Controller */
export default class PickService {
	/**
	 * Get the current user's picks for the provided event id.
	 *
	 * @param {number} eventId The event to view picks for.
	 * @param {number} userId The user to view picks for.
	 * @returns {Promise<EventPicksDto>}
	 */
	static async getUserPicks(eventId, userId = null) {
		const userIdQuery = userId ? `?userId=${userId}` : "";
		return await axiosWrapper.get(
			`${baseUrl}/get/user/${eventId}${userIdQuery}`
		);
	}

	/**
	 * Gets a champion ("Going All The Way") pick, or null.
	 *
	 * @param {number} eventId
	 * @param {number} userId The user to view the pick for; defaults to the current user.
	 */
	static async getChampionPick(eventId, userId = null) {
		const userIdQuery = userId ? `?userId=${userId}` : "";
		return await axiosWrapper.get(
			`${baseUrl}/get/champion/${eventId}${userIdQuery}`
		);
	}

	/**
	 * Saves the current user's champion pick, replacing any previous one.
	 *
	 * @param {number} eventId
	 * @param {number} teamId
	 */
	static async saveChampionPick(eventId, teamId) {
		return await axiosWrapper.post(`${baseUrl}/save/champion/${eventId}`, {
			teamId,
		});
	}

	/**
	 * Saves the current users picks.
	 *
	 * @param {number} eventId
	 * @param {EventPicksDto} picks
	 */
	static async saveUserPicks(eventId, picks) {
		// The server rejects any pick whose eventId disagrees with the route id.
		for (const groupPick of picks.groupStagePicks) {
			groupPick.eventId = eventId;
			groupPick.userId = UserManager.getUserId();
		}
		for (const groupPick of picks.matchPicks) {
			groupPick.eventId = eventId;
			groupPick.userId = UserManager.getUserId();
		}

		return await axiosWrapper.post(`${baseUrl}/save/user/${eventId}`, picks);
	}
}
